import DashboardMonitoramento from '@/views/monitoramento/DashboardMonitoramento';
import DashboardMonitoramentoMapeamento from '@/views/monitoramento/mapeamento/DashboardMonitoramentoMapeamento';
import MonitoramentoMapeamentoEstruturaUnidades
from '@/views/monitoramento/mapeamento/unidades/MonitoramentoMapeamentoEstruturaUnidades';
import MonitoramentoMapeamentoComportamental
from '@/views/monitoramento/mapeamento/comportamento/MonitoramentoMapeamentoComportamental';
import MonitoramentoMapeamentoResponsabilidade
from '@/views/monitoramento/mapeamento/responsabilidade/MonitoramentoMapeamentoResponsabilidade';
import DashboardMonitoramentoDesempenho from '@/views/monitoramento/desempenho/DashboardMonitoramentoDesempenho';
import MonitoramentoDesempenhoComportamental
from '@/views/monitoramento/desempenho/comportamento/MonitoramentoDesempenhoComportamental';
import MonitoramentoDesempenhoResponsabilidade
from '@/views/monitoramento/desempenho/responsabilidade/MonitoramentoDesempenhoResponsabilidade';
import MonitoramentoCoeficienteDesempenho
from '@/views/monitoramento/desempenho/coeficiente/MonitoramentoCoeficienteDesempenho';
import DashboardMonitoramentoPerfil from '@/views/monitoramento/perfil/DashboardMonitoramentoPerfil';
import MonitoramentoPerfil from '@/views/monitoramento/perfil/MonitoramentoPerfil';
import DashboardMonitoramentoDiagnostico from '@/views/monitoramento/diagnostico/DashboardMonitoramentoDiagnostico';
import MonitoramentoDiagnosticoComportamental
from '@/views/monitoramento/diagnostico/comportamental/MonitoramentoDiagnosticoComportamental';
import MonitoramentoDiagnosticoTecnico from '@/views/monitoramento/diagnostico/tecnico/MonitoramentoDiagnosticoTecnico';

const MonitoramentoRoutes = [
  {
    path: '/monitoramento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardMonitoramento',
    component: DashboardMonitoramento,
  },
  {
    path: '/monitoramento/mapeamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Mapeamento' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardMonitoramentoMapeamento',
    component: DashboardMonitoramentoMapeamento,
  },
  {
    path: '/monitoramento/mapeamento/estrutura-unidades',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Mapeamento', href: '/monitoramento/mapeamento' },
        { position: 4, text: 'Estrutura das Unidades' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoMapeamentoEstruturaUnidades',
    component: MonitoramentoMapeamentoEstruturaUnidades,
  },
  {
    path: '/monitoramento/mapeamento/comportamental',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Mapeamento', href: '/monitoramento/mapeamento' },
        { position: 4, text: 'Competências Comportamentais' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoMapeamentoComportamental',
    component: MonitoramentoMapeamentoComportamental,
  },
  {
    path: '/monitoramento/mapeamento/responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Mapeamento', href: '/monitoramento/mapeamento' },
        { position: 4, text: 'Competências Técnicas' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoMapeamentoResponsabilidade',
    component: MonitoramentoMapeamentoResponsabilidade,
  },
  {
    path: '/monitoramento/desempenho',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Desempenho' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardMonitoramentoDesempenho',
    component: DashboardMonitoramentoDesempenho,
  },
  {
    path: '/monitoramento/desempenho/comportamental',
    name: 'MonitoramentoDesempenhoComportamental',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Desempenho', href: '/monitoramento/desempenho' },
        { position: 4, text: 'Desempenho Comportamental' },
      ],
      requiresAuth: true,
    },
    component: MonitoramentoDesempenhoComportamental,
  },
  {
    path: '/monitoramento/desempenho/responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Desempenho', href: '/monitoramento/desempenho' },
        { position: 4, text: 'Desempenho Técnico' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoDesempenhoResponsabilidade',
    component: MonitoramentoDesempenhoResponsabilidade,
  },
  {
    path: '/monitoramento/desempenho/coeficiente',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Desempenho', href: '/monitoramento/desempenho' },
        { position: 4, text: 'Coeficiente de Desempenho do Servidor (CDS)' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoCoeficienteDesempenho',
    component: MonitoramentoCoeficienteDesempenho,
  },
  {
    path: '/monitoramento/perfil',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Perfil' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoPerfil',
    component: DashboardMonitoramentoPerfil,
  },
  {
    path: '/monitoramento/perfil/filtro',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Perfil', href: '/monitoramento/perfil' },
        { position: 4, text: 'Filtros de Busca do Perfil' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoPerfilFiltro',
    component: MonitoramentoPerfil,
  },
  {
    path: '/monitoramento/perfil/relatorio',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Perfil', href: '/monitoramento/perfil' },
        { position: 4, text: 'Relatórios Gerais do Perfil' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoPerfilRelatorio',
    component: MonitoramentoPerfil,
  },
  {
    path: '/monitoramento/diagnostico',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Diagnóstico' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardMonitoramentoDiagnostico',
    component: DashboardMonitoramentoDiagnostico,
  },
  {
    path: '/monitoramento/diagnostico/comportamental',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Diagnóstico', href: '/monitoramento/diagnostico' },
        { position: 4, text: 'Diagnóstico Comportamental' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoDiagnosticoComportamental',
    component: MonitoramentoDiagnosticoComportamental,
  },
  {
    path: '/monitoramento/diagnostico/tecnico',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Monitoramento', href: '/monitoramento' },
        { position: 3, text: 'Monitoramento do Diagnóstico', href: '/monitoramento/diagnostico' },
        { position: 4, text: 'Diagnóstico Técnico' },
      ],
      requiresAuth: true,
    },
    name: 'MonitoramentoDiagnosticoTecnico',
    component: MonitoramentoDiagnosticoTecnico,
  },
];

export default MonitoramentoRoutes;
